export const menuShowAction = (payload) => {
    return {
        type: "menuShow",
        payload
    }
};
